import React from 'react';

import fallBackImage from 'assets/images/imagecache_defaults.png';

const swapFallbackImageSrc = (event: React.SyntheticEvent<HTMLImageElement>): void => {
    event.currentTarget.src = fallBackImage;
};

const FailsafeImg: React.StatelessComponent<React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>> = (props) => {
    return <img {...props} onError={swapFallbackImageSrc} />;
};

export default FailsafeImg;



// WEBPACK FOOTER //
// ./src/components/global/application/FailsafeImg.tsx